import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ children }) {
  return (
    <div className="max-w-none" data-testid="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h1 className="font-display text-3xl sm:text-4xl text-brand mt-10 mb-4 leading-tight" {...p} />,
          h2: ({ node, ...p }) => <h2 className="font-display text-2xl sm:text-3xl text-brand mt-10 mb-3 leading-tight" {...p} />,
          h3: ({ node, ...p }) => <h3 className="font-display text-xl text-brand mt-8 mb-2" {...p} />,
          p: ({ node, ...p }) => <p className="text-brand-muted leading-relaxed mb-5 text-[15px]" {...p} />,
          a: ({ node, ...p }) => <a className="text-brand-terracotta underline underline-offset-2 hover:text-brand-hover" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-6 mb-5 space-y-2 text-brand-muted text-[15px]" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-6 mb-5 space-y-2 text-brand-muted text-[15px]" {...p} />,
          li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-semibold text-brand" {...p} />,
          em: ({ node, ...p }) => <em className="italic" {...p} />,
          blockquote: ({ node, ...p }) => (
            <blockquote className="border-l-4 border-brand-ochre bg-brand-surface pl-5 pr-4 py-4 my-6 rounded-sm font-display text-lg text-brand italic" {...p} />
          ),
          hr: () => <hr className="my-10 border-brand/10" />,
          img: ({ node, ...p }) => <img className="rounded-sm w-full my-6" alt="" {...p} />,
          code: ({ node, ...p }) => <code className="bg-brand-surface px-1.5 py-0.5 rounded text-sm text-brand" {...p} />,
          table: ({ node, ...p }) => <table className="w-full my-6 text-sm border border-brand/10" {...p} />,
          th: ({ node, ...p }) => <th className="border border-brand/10 bg-brand-surface px-3 py-2 text-left text-brand" {...p} />,
          td: ({ node, ...p }) => <td className="border border-brand/10 px-3 py-2 text-brand-muted" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
